import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Card } from '@mui/material';

const remindersData = [
  { id: 1, message: 'Reminder: Take your medication at 8 PM.' },
  { id: 2, message: 'Reminder: Schedule your annual check-up.' },
  { id: 3, message: 'Reminder: Drink 8 glasses of water today.' },
  { id: 4, message: 'Reminder: Check your blood pressure weekly.' }
];

const RemindersPage = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#121212',
        color: 'white',
        p: 4,
        pt: { xs: '4rem', sm: '4.5rem', md: '5rem' },
        borderRadius: 2,
        boxShadow: 3
      }}
    >
      <Typography variant='h3' sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}>
        Reminders
      </Typography>
      <List>
        {remindersData.map((reminder) => (
          <ListItem key={reminder.id} sx={{ mb: 2 }}>
            <Card
              sx={{
                backgroundColor: '#1f1f1f',
                borderRadius: 1,
                boxShadow: 1,
                width: '100%',
                padding: 2,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.02)'
                }
              }}
            >
              <ListItemText primary={reminder.message} sx={{ color: 'white' }} />
            </Card>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default RemindersPage;
